export const SimplePricingCardData = [
  {
    type: 'Standard',
    price: 15,
    subTitle: 'Standard Price',
  },
  {
    type: 'Business',
    price: 25,
    subTitle: 'Business Price',
  },
  {
    type: 'Premium',
    price: 35,
    subTitle: 'Premium Price',
  },
  {
    type: 'Extra',
    price: 45,
    subTitle: 'Extra Price',
  },
];

export const PricingDetailData = [
  {
    type: 'standard',
    price: 10,
    duration: 'month',
    benefit: [
      {
        title: 'Disk Space',
        beni: 50,
        unit: 'GB',
      },
      { title: 'Email Accounts', beni: 50 },
      { title: 'Bandwidth', beni: 50, unit: 'GB' },
      { title: 'Subdomains', beni: 10 },
      { title: 'Domains', beni: 15 },
    ],
  },
  {
    type: 'Business',
    price: 20,
    duration: 'month',
    benefit: [
      {
        title: 'Disk Space',
        beni: 60,
        unit: 'GB',
      },
      { title: 'Email Accounts', beni: 60 },
      { title: 'Bandwidth', beni: 60, unit: 'GB' },
      { title: 'Subdomains', beni: 15 },
      { title: 'Domains', beni: 20 },
    ],
  },
  {
    type: 'Premium',
    price: 30,
    duration: 'month',
    benefit: [
      {
        title: 'Disk Space',
        beni: 70,
        unit: 'GB',
      },
      { title: 'Email Accounts', beni: 70 },
      { title: 'Bandwidth', beni: 70, unit: 'GB' },
      { title: 'Subdomains', beni: 25 },
      { title: 'Domains', beni: 30 },
    ],
  },
  {
    type: 'Other Pack',
    price: 40,
    duration: 'month',
    benefit: [
      {
        title: 'Disk Space',
        beni: 80,
        unit: 'GB',
      },
      { title: 'Email Accounts', beni: 80 },
      { title: 'Bandwidth', beni: 80, unit: 'GB' },
      { title: 'Subdomains', beni: 25 },
      { title: 'Domains', beni: 30 },
    ],
  },
];
